import apiUsuarios from '../http-common/http-common-api-usuarios'

class ApiUsuarios {
    autenticarUsuario(data){
        return apiUsuarios.post("/usuario/autenticar", data)
    }
}

export default new ApiUsuarios()